import { RawStructure, Structure } from "@/types/structure";

export const mapRawToStructure = (raw: RawStructure): Structure => {
  return {
    deviceClass: raw.device_class,
    id: raw.id,
    isReferenceWaveGuide: raw.is_reference_waveguide,
    refWaveguides: raw.ref_waveguides,
    name: raw.name,
    testSiteName: raw.test_site_name,
    isCustom: raw.is_custom,
    nrOfPortCombos: raw.port_combos?.length ?? 0,
  };
};
